"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _glamor = require("glamor");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _ConnectivityStatus = _interopRequireDefault(require("./SendBox/ConnectivityStatus"));

var _connectToWebChat = _interopRequireDefault(require("./connectToWebChat"));

var _DictationInterims = _interopRequireDefault(require("./SendBox/DictationInterims"));

var _MicrophoneButton = _interopRequireDefault(require("./SendBox/MicrophoneButton"));

var _SendButton = _interopRequireDefault(require("./SendBox/SendButton"));

var _SuggestedActions = _interopRequireDefault(require("./SendBox/SuggestedActions"));

var _TextBox = _interopRequireDefault(require("./SendBox/TextBox"));

var _UploadButton = _interopRequireDefault(require("./SendBox/UploadButton"));

var _botframeworkWebchatCore = require("botframework-webchat-core");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _Constants$DictateSta = _botframeworkWebchatCore.Constants.DictateState,
    DICTATING = _Constants$DictateSta.DICTATING,
    STARTING = _Constants$DictateSta.STARTING;
var ROOT_CSS = (0, _glamor.css)({
  '& > .main': {
    display: 'flex'
  }
});
var DICTATION_INTERIMS_CSS = (0, _glamor.css)({
  flex: 10000
});
var MICROPHONE_BUTTON_CSS = (0, _glamor.css)({
  flex: 1
});
var TEXT_BOX_CSS = (0, _glamor.css)({
  flex: 10000
});

var BasicSendBox = function BasicSendBox(_ref) {
  var className = _ref.className,
      dictationStarted = _ref.dictationStarted,
      styleSet = _ref.styleSet,
      webSpeechPonyfill = _ref.webSpeechPonyfill;
  return _react.default.createElement("div", {
    className: (0, _classnames.default)(styleSet.sendBox + '', ROOT_CSS + '', (className || '') + ''),
    role: "form"
  }, _react.default.createElement(_ConnectivityStatus.default, null), _react.default.createElement(_SuggestedActions.default, null), _react.default.createElement("div", {
    className: "main"
  }, !styleSet.options.hideUploadButton && _react.default.createElement(_UploadButton.default, null), dictationStarted ? _react.default.createElement(_DictationInterims.default, {
    className: DICTATION_INTERIMS_CSS
  }) : _react.default.createElement(_TextBox.default, {
    className: TEXT_BOX_CSS
  }), _react.default.createElement("div", null, (webSpeechPonyfill || {}).SpeechRecognition ? _react.default.createElement(_MicrophoneButton.default, {
    className: MICROPHONE_BUTTON_CSS
  }) : _react.default.createElement(_SendButton.default, null))));
};

var _default = (0, _connectToWebChat.default)(function (_ref2) {
  var dictateState = _ref2.dictateState,
      styleSet = _ref2.styleSet,
      webSpeechPonyfill = _ref2.webSpeechPonyfill;
  return {
    dictationStarted: dictateState === STARTING || dictateState === DICTATING,
    styleSet: styleSet,
    webSpeechPonyfill: webSpeechPonyfill
  };
})(BasicSendBox);

exports.default = _default;